import React from 'react';
import PropTypes from 'prop-types';

import { strings } from './../../../localization';
import ProgressOverlay from './../../../components/common/ProgressOverlay';

import { UPDATE_SETTINGS_TIMEOUT } from './GlobalSettings';

export default class UnitsOfMeasure extends React.PureComponent {

    static propTypes = {
        unitOfMeasureDistancePending: PropTypes.bool.isRequired,
        unitOfMeasureDistanceIsMetric: PropTypes.bool,
        unitOfMeasureDistanceErrorMessage: PropTypes.string,
        applyUnitOfMeasureDistance: PropTypes.func.isRequired,
        timeoutUnitOfMeasureDistance: PropTypes.func.isRequired,
        unitOfMeasureTemperaturePending: PropTypes.bool.isRequired,
        unitOfMeasureTemperatureIsMetric: PropTypes.bool,
        unitOfMeasureTemperatureErrorMessage: PropTypes.string,
        applyUnitOfMeasureTemperature: PropTypes.func.isRequired,
        timeoutUnitOfMeasureTemperature: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        unitOfMeasureExpandReference: PropTypes.string.isRequired,
        unitOfMeasureExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        unitOfMeasureDistanceExpandReference: PropTypes.string.isRequired,
        unitOfMeasureDistanceExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        unitOfMeasureTemperatureExpandReference: PropTypes.string.isRequired,
        unitOfMeasureTemperatureExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.applyUnitOfMeasureDistanceTimeoutId = undefined;
        this.applyUnitOfMeasureTemperatureTimeoutId = undefined;

    }

    componentWillUnmount() {
        clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId);
        clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId);
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.unitOfMeasureExpandReference,
            this.props.unitOfMeasureDistanceExpandReference,
            this.props.unitOfMeasureTemperatureExpandReference
        ]);
    }

    render() {

        return (
            <div id="component_document_id_units_of_measure">
                <h3>
                    <button
                        className={this.props.unitOfMeasureExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.unitOfMeasureExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_unit_of_measure_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div>{strings.settings_global_unit_of_measure_description}</div>
                <div className='setting-group-horiz'>

                    <div className={this.props.unitOfMeasureDistanceExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.unitOfMeasureDistanceExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.unitOfMeasureDistanceExpandReferenceIsExpanded,
                                        [this.props.unitOfMeasureDistanceExpandReference])
                                }}>
                                {strings.settings_global_unit_of_measure_distance_header}
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                        <div className='setting-group radio-group'>
                            <div>
                                <input type="radio" name="distance" id="distance:imperial"
                                    value={false}
                                    checked={this.props.unitOfMeasureDistanceIsMetric === false}
                                    onChange={() => {

                                        clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId);
                                        this.applyUnitOfMeasureDistanceTimeoutId = setTimeout(() => {this.props.timeoutUnitOfMeasureDistance(true)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.applyUnitOfMeasureDistance(false)
                                        .then(
                                            () => {clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId)},
                                            () => {clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId)}
                                        )
                                    }}
                                    disabled={this.props.unitOfMeasureDistancePending}
                                />
                                <label htmlFor='distance:imperial' disabled={this.props.unitOfMeasureDistancePending}>{strings.prefs_uom_imperial_short}</label>
                            </div>
                            <div>
                                <input type="radio" name="distance" id="distance:metric"
                                    value={true}
                                    checked={this.props.unitOfMeasureDistanceIsMetric === true}
                                    onChange={() => {

                                        clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId);
                                        this.applyUnitOfMeasureDistanceTimeoutId = setTimeout(() => {this.props.timeoutUnitOfMeasureDistance(false)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.applyUnitOfMeasureDistance(true)
                                        .then(
                                            () => {clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId)},
                                            () => {clearTimeout(this.applyUnitOfMeasureDistanceTimeoutId)}
                                        )
                                    }}
                                    disabled={this.props.unitOfMeasureDistancePending}
                                />
                                <label htmlFor='distance:metric' disabled={this.props.unitOfMeasureDistancePending}>{strings.prefs_uom_metric_short}</label>
                            </div>
                            <div className="error-message">
                                {this.props.unitOfMeasureDistanceErrorMessage}
                            </div>
                            {this.props.unitOfMeasureDistancePending ? <ProgressOverlay /> : null }
                        </div>
                    </div>
                </div>
                <div className='setting-group-horiz'>
                    <div className={this.props.unitOfMeasureTemperatureExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.unitOfMeasureTemperatureExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.unitOfMeasureTemperatureExpandReferenceIsExpanded,
                                        [this.props.unitOfMeasureTemperatureExpandReference])
                                }}>
                                {strings.settings_global_unit_of_measure_temperature_header}
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                        <div className='setting-group radio-group'>
                            <div>
                                <input type="radio" name="temperature" id="temperature:farenheit"
                                    value={false}
                                    checked={this.props.unitOfMeasureTemperatureIsMetric === false}
                                    onChange={() => {

                                        clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId);
                                        this.applyUnitOfMeasureTemperatureTimeoutId = setTimeout(() => {this.props.timeoutUnitOfMeasureTemperature(true)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.applyUnitOfMeasureTemperature(false)
                                        .then(
                                            () => {clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId)},
                                            () => {clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId)}
                                        )
                                    }}
                                    disabled={this.props.unitOfMeasureTemperaturePending}
                                />
                                <label htmlFor='temperature:farenheit' disabled={this.props.unitOfMeasureTemperaturePending}>{strings.prefs_uom_fahrenheit_short}</label>
                            </div>
                            <div>
                                <input type="radio" name="temperature" id="temperature:celcius"
                                    value={true}
                                    checked={this.props.unitOfMeasureTemperatureIsMetric === true}
                                    onChange={() => {

                                        clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId);
                                        this.applyUnitOfMeasureTemperatureTimeoutId = setTimeout(() => {this.props.timeoutUnitOfMeasureTemperature(false)}, UPDATE_SETTINGS_TIMEOUT);

                                        this.props.applyUnitOfMeasureTemperature(true)
                                        .then(
                                            () => {clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId)},
                                            () => {clearTimeout(this.applyUnitOfMeasureTemperatureTimeoutId)}
                                        )
                                    }}
                                    disabled={this.props.unitOfMeasureTemperaturePending}
                                />
                                <label htmlFor='temperature:celcius' disabled={this.props.unitOfMeasureTemperaturePending}>{strings.prefs_uom_celsius_short}</label>
                            </div>
                            <div className="error-message">
                                {this.props.unitOfMeasureTemperatureErrorMessage}
                            </div>
                            {this.props.unitOfMeasureTemperaturePending ? <ProgressOverlay /> : null }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}